module.exports = __webpack_public_path__ + "static-portal/img/18-1.05b0713.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/18-1.jpg
// module id = yC4h
// module chunks = 4